// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader___1nM1b","spin":"spin___1yxYw"};